import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import Nav from '@/components/Nav.vue';
import Layout from '@/components/Layout.vue';
import Icon from '@/components/icon.vue';


Vue.config.productionTip = false;

Vue.component('Layout', Layout);
Vue.component('Nav', Nav);
Vue.component('Icon',Icon);



new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

window.onload = function(){
    setTimeout(function(){
        window.scrollTo(0,200);//滚动到页面指定位置
    },0)
};

if(document.documentElement.clientWidth>500){
    window.alert("手机打开本页面可保证浏览效果")
}
